import cn from "classnames";
import { FC, ReactNode } from "react";
import { Link } from "../Link";

interface Props {
  className?: string;
  label: string;
  href?: string;
  isOpenNewTab?: boolean;
  isExternalLink?: boolean;
  children: ReactNode;
}

export const CardInfoParam: FC<Props> = ({
  label,
  href,
  isOpenNewTab,
  isExternalLink = true,
  children,
  className,
}) => {
  if (!children) return null;

  return (
    <div className={cn("flex gap-2.5 items-center font-semibold", className)}>
      <span className="text-purple-base">{label}</span>

      <Link
        className={cn("!scale-100", {
          "hover:text-purple-base hover:underline": href,
        })}
        href={href}
        isOpenNewTab={isOpenNewTab}
        isExternalLink={isExternalLink}
      >
        {children}
      </Link>
    </div>
  );
};
